import React from 'react';

import clsx from 'clsx';

import type { BaseComponentProps } from '@coursera/cds-common';

import getContentCss, { classes } from './styles/getContentCss';

export type Props = BaseComponentProps<'div'>;

const Content = React.forwardRef(function Content(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, className, ...rest } = props;

  return (
    <div
      ref={ref}
      className={clsx(className, classes.root)}
      css={getContentCss}
      {...rest}
    >
      {children}
    </div>
  );
});

if (__DEV__) {
  Content.displayName = 'TemporaryDrawer.Content';
}

export default Content;
